import { inject, Injectable } from '@angular/core';
import { SwUpdate, VersionEvent } from '@angular/service-worker';
import { ToastController, ToastButton } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root',
})
export class AppUpdateService {
  private translate = inject(TranslateService);
  private toast = inject(ToastController);
  private updates = inject(SwUpdate);
  private isUpdating = false;

  init() {
    if (!this.updates.isEnabled) {
      console.log('[AppUpdateService] Service Worker désactivé');
      return;
    }

    this.updates.versionUpdates.subscribe((evt: VersionEvent) => {
      console.log('[AppUpdateService] Event:', evt);

      switch (evt.type) {
        case 'VERSION_DETECTED':
          console.log('[AppUpdateService] Nouvelle version détectée');
          break;

        case 'VERSION_READY':
          console.log('[AppUpdateService] Nouvelle version prête');
          this.applyUpdate().finally(() => {});
          break;

        case 'NO_NEW_VERSION_DETECTED':
          console.log('[AppUpdateService] Aucune nouvelle version');
          break;
      }
    });

    this.updates.unrecoverable.subscribe((event) => {
      console.error('[AppUpdateService] Erreur critique SW', event);
      this.showToast(
        this.translate.instant('ServiceWorkerUpdateError'),
        'danger',
      );
      setTimeout(() => document.location.reload(), 2000);
    });

    this.updates.checkForUpdate().catch((err) => {
      console.error('[AppUpdateService] checkForUpdate error:', err);
    });
  }

  private async applyUpdate() {
    if (this.isUpdating) return;
    this.isUpdating = true;

    this.showToast(
      this.translate.instant('ServiceWorkerUpdateInProgress'),
      'info',
      2000,
    );

    try {
      await this.updates.activateUpdate();
      await this.showToast(
        this.translate.instant('ServiceWorkerUpdateDone'),
        'success',
        1500,
      );
      setTimeout(() => document.location.reload(), 1500);
    } catch (err) {
      console.error('[AppUpdateService] activateUpdate error:', err);
      this.showToast(
        this.translate.instant('ServiceWorkerUpdateError'),
        'danger',
      );
    } finally {
      this.isUpdating = false;
    }
  }

  private async showToast(
    message: string,
    color: 'success' | 'danger' | 'warning' | 'info',
    duration = 3000,
    buttons?: ToastButton[],
  ) {
    const toast = await this.toast.create({
      message,
      duration: duration === 0 ? undefined : duration,
      position: 'top',
      color,
      buttons,
      mode: 'ios',
    });
    await toast.present();
  }
}
